var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-preview"},[_c('img',{staticClass:"thumb",attrs:{"src":_vm.src},on:{"click":_vm.openPreview}}),(_vm.visible)?_c('div',{staticClass:"preview-mask",on:{"click":_vm.closePreview}},[_c('img',{staticClass:"preview-img",attrs:{"src":_vm.src}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }